<h2 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>Mein Profil</span>
    <button mat-icon-button type="button" (click)="close()" matTooltip="Schließen">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<div class="profile-dialog-content">
    <form [formGroup]="form">

        <div class="profile-layout" fxLayout="row" fxLayoutGap="24px" fxLayoutAlign="start start">

            <!-- Linke Spalte: Avatar -->
            <div class="avatar-column" fxLayout="column" fxLayoutAlign="start center" fxFlex="0 0 110px">
                <div class="avatar-wrapper" (click)="onAvatarClick(fileInput)" matTooltip="Profilbild ändern">
                    <ng-container *ngIf="avatarPreviewUrl; else existingImage">
                        <img class="avatar-img" [src]="avatarPreviewUrl" alt="Profilbild Vorschau"/>
                    </ng-container>
                    <ng-template #existingImage>
                        <u2b-secured-image-u2b
                            class="avatar-img"
                            [file]="currentImage"
                            [placeholder]="avatarPlaceholder">
                        </u2b-secured-image-u2b>
                    </ng-template>
                    <div class="avatar-overlay">
                        <mat-icon *ngIf="!isUploadingImage">photo_camera</mat-icon>
                        <mat-spinner *ngIf="isUploadingImage" diameter="24"></mat-spinner>
                    </div>
                </div>
                <button *ngIf="currentImage || avatarPreviewUrl"
                        mat-button color="warn" type="button"
                        class="remove-avatar-btn"
                        (click)="removeAvatar()">
                    <mat-icon>delete</mat-icon>
                    Entfernen
                </button>
                <input #fileInput type="file" accept="image/*" hidden (change)="onFileSelected($event)"/>
            </div>

            <!-- Rechte Spalte: Formularfelder -->
            <div fxFlex fxLayout="column" fxLayoutGap="0">

                <!-- Anrede & Titel -->
                <div fxLayout="row" fxLayoutGap="12px">
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>Anrede</mat-label>
                        <mat-select formControlName="salutation">
                            <mat-option *ngFor="let opt of salutationOptions" [value]="opt.value">
                                {{ opt.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>Titel</mat-label>
                        <input matInput formControlName="title" placeholder="z.B. Dr.">
                    </mat-form-field>
                </div>

                <!-- Vorname & Nachname -->
                <div fxLayout="row" fxLayoutGap="12px">
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>Vorname *</mat-label>
                        <input matInput formControlName="firstName">
                        <mat-error *ngIf="form.get('firstName').hasError('required')">Pflichtfeld</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>Nachname *</mat-label>
                        <input matInput formControlName="lastName">
                        <mat-error *ngIf="form.get('lastName').hasError('required')">Pflichtfeld</mat-error>
                    </mat-form-field>
                </div>

                <!-- E-Mail (readonly) & E-Mail 2 -->
                <div fxLayout="row" fxLayoutGap="12px">
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>E-Mail (Anmeldung)</mat-label>
                        <input matInput formControlName="email">
                        <mat-hint>Kann nicht geändert werden</mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>E-Mail 2</mat-label>
                        <input matInput formControlName="email2" type="email">
                    </mat-form-field>
                </div>

                <!-- Telefon & Handy -->
                <div fxLayout="row" fxLayoutGap="12px">
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>Telefon</mat-label>
                        <input matInput formControlName="phone" type="tel">
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-label>Handy</mat-label>
                        <input matInput formControlName="mobilePhone" type="tel">
                    </mat-form-field>
                </div>

                <!-- Geburtsdatum -->
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'person.core.birthDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="birthDatePicker" formControlName="birthDate">
                    <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker></mat-datepicker>
                </mat-form-field>

                <!-- Straße -->
                <mat-form-field appearance="outline">
                    <mat-label>Straße</mat-label>
                    <input matInput formControlName="street">
                </mat-form-field>

                <!-- PLZ & Stadt -->
                <div fxLayout="row" fxLayoutGap="12px">
                    <mat-form-field appearance="outline" fxFlex="35">
                        <mat-label>PLZ</mat-label>
                        <input matInput formControlName="postcode">
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="65">
                        <mat-label>Stadt</mat-label>
                        <input matInput formControlName="city">
                    </mat-form-field>
                </div>

                <!-- Land -->
                <mat-form-field appearance="outline">
                    <mat-label>Land</mat-label>
                    <input matInput formControlName="country">
                </mat-form-field>

            </div>
        </div>

    </form>
</div>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Abbrechen</button>
    <button mat-raised-button color="accent" type="button"
            [disabled]="form.invalid || isSaving || isUploadingImage"
            (click)="save()">
        <mat-icon *ngIf="!isSaving">save</mat-icon>
        <mat-spinner *ngIf="isSaving" diameter="20" class="mr-8"></mat-spinner>
        Speichern
    </button>
</mat-dialog-actions>
